import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const ButtonSecondary = ({ plan, btn, link, url, updatePlan, monthly, id, togglePopup, popup, externalLink }) => {

  let cta;

  let upgrade = <FormattedMessage id="admin.pricing.card.btn2" defaultMessage="Upgrade plan" />;
  let downgrade = <FormattedMessage id="admin.pricing.card.btn1.downgrade" defaultMessage="Downgrade plan" />;
  let contactUs = <FormattedMessage id="admin.pricing.card.btn3" defaultMessage="Contact us" />;
  let current = <FormattedMessage id="admin.pricing.card.btn1" defaultMessage="Extend plan" />;

  if (plan === btn) {
    cta = current;
  } else if (plan < btn && btn !== 33) {
    cta = upgrade;
  } else if (plan > btn) {
    cta = downgrade;
  } else if (plan < btn && btn === 33) {
    cta = contactUs;
  }

  let time = monthly ? 1 : 12;

  // Create payment link
  let paymentLink = '';

  if (monthly) {
    // Monthly plans
    if (btn === 3) {
      // Pro
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/b4cf3cea-aebe-4882-aebb-1c44e900af6d';
    } else if (btn === 4) {
      // Pro + Culture
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/fa3fa983-fba3-492d-90b5-7f46fb084fe5';
    } else if (btn === 2) {
      // Checkins
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/558ad76a-c14c-4ecd-b53d-50224b990e2e';
    } else if (btn === 2.5) {
      // Checkins + Cultures
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/d8151279-935c-45e0-9f84-fc50488c924d';
    }
  } else {

    // Yearly plans
    if (btn === 3) {
      // Pro
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/b0edd975-b0f1-439c-8ded-a8071a514dd0';
    } else if (btn === 4) {
      // Pro + Culture
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/7ee4c752-2fa0-4cd2-bfd2-ce521657027d';
    } else if (btn === 2) {
      // Checkins
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/ba51f081-7274-4fcc-ad0d-af95912e6e16';
    } else if (btn === 2.5) {
      // Checkins + Cultures
      paymentLink = 'https://smartokr.lemonsqueezy.com/checkout/buy/cee57e68-33e9-4b97-a11e-90a92bab9580';
    }
  }

  return (
    <Fragment>
      {!link ? (
        <Fragment>
          {plan === btn ? (
            <button className="btn-secondary btn-secondary-comment lh-unset h-unset py-2">{cta}</button>
          ) : (
             plan > btn ? (
             <button 
                className="btn-secondary btn-secondary-comment lh-unset h-unset py-2"
                onClick={() => { if (window.confirm('Are you sure you wish to downgrade your plan? You will lose all benefits from your plan.')) updatePlan(btn, time, id, btn) } }
              >
                {cta}</button>
              ) : 
              (
                  <button 
                    className="btn-secondary btn-secondary-comment lh-unset h-unset py-2"
                    onClick={() => togglePopup(!popup)}
                  >
                    {cta}</button>
              )
          )}
        </Fragment>
      ) : (
          externalLink !== 99 ? (
            externalLink !== 1 ? (
            <Link to={url} className="btn-secondary btn-secondary-comment lh-unset h-unset py-2">{cta}</Link>) : 
            (<a href={url} className="btn-secondary btn-secondary-comment lh-unset h-unset py-2" rel="noopener noreferrer">{cta}</a>)
            ) : (
              <a href={paymentLink} className="btn-secondary btn-secondary-comment lh-unset h-unset py-2 lemonsqueezy-button" rel="noopener noreferrer">{cta}</a>
            )
      )}
    </Fragment>
  );
};

ButtonSecondary.propTypes = {
  plan: PropTypes.number.isRequired,
  btn: PropTypes.number.isRequired,
  link: PropTypes.bool,
  url: PropTypes.string,
  externalLinkl: PropTypes.number
};

export default ButtonSecondary;